import React from "react";
import { Main } from "../components/sections/productDetails/Main";

export const ProductDetails = () => {
  return <Main />;
};
